import { Box, Text, Image, ScrollView } from '@betty/moonlight';
import { Page } from '@betty/navigation';
import privacyPolicySections from './PrivacyPolicy.content';

function PrivacyPolicy() {
  return (
    <Page>
      <ScrollView>
        <Box
          alignItems="center"
          paddingBottom="space-600"
          paddingHorizontal="space-400"
        >
          <Box width="100%" maxWidth={767} flexDirection="column">
            <Box
              width="100%"
              height={225}
              position="relative"
              justifyContent="center"
              alignItems="center"
            >
              <Image
                name="misc.privacyCover"
                width="100%"
                height={225}
                contentFit="cover"
              />
            </Box>

            <Box flexDirection="column" gap="space-400" paddingTop="space-400">
              <Text
                variant="h4"
                gradient="darkSurfaceAccent"
                locNS="account"
                locKey="privacyHeader"
                marginBottom="space-400"
              />
              <Text
                variant="body-m"
                color="darkSurfacePrimary"
                marginBottom="space-400"
              >
                Last Updated: 09/05/2024
              </Text>

              {privacyPolicySections.map(({ headerKey, textKey }) => (
                <Box
                  key={headerKey}
                  flexDirection="column"
                  marginBottom="space-600"
                >
                  <Text
                    variant="h5"
                    gradient="darkSurfaceAccent"
                    locNS="account"
                    locKey={headerKey}
                    marginBottom="space-400"
                  />
                  <Text
                    variant="body-m"
                    color="darkSurfacePrimary"
                    locNS="account"
                    locKey={textKey}
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </ScrollView>
    </Page>
  );
}

export default PrivacyPolicy;
